import { useEffect } from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import MovieCard from '@/components/base/MovieCard';
import { categories, getMoviesByCategory } from '@/mocks/movies';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();
  const currentCategory = categories.find((c) => c.slug === slug);
  const movies = slug ? getMoviesByCategory(slug) : [];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  if (!currentCategory) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground-900">分类不存在</h1>
            <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: currentCategory.name },
  ];

  return (
    <>
      <Navbar />
      <main className="pt-20 md:pt-24 pb-14 md:pb-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="mb-4">
            <Breadcrumb items={breadcrumbItems} />
          </div>

          <div className="mb-8 md:mb-10">
            <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              {currentCategory.name}
            </h1>
            <p className="mt-2 text-sm md:text-base text-foreground-600">{currentCategory.description}</p>
          </div>

          <div className="flex flex-wrap items-center gap-2 mb-8 md:mb-10">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  cat.slug === slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/70'
                }`}
              >
                <i className={`${cat.icon} text-xs`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          {movies.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {movies.map((movie) => (
                <MovieCard key={movie.id} {...movie} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200">
                <i className="ri-film-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500">该分类暂无电影推荐</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}